import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Col,
    Container,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap";
import { submitQrRequest } from "../../store/actions/MomentosActions";
import { toast } from "react-toastify";

const RequestQRCode = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.authUser);
    const [email, setEmail] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        let payload = {
            userId: user?.id,
            userName: user?.first_name + " " + user?.last_name,
            email,
        };
        dispatch(
            submitQrRequest(payload, () => {
                toast.success("Request for QR Code Sent Successfully");
                setEmail("");
            })
        );
    };
    return (
        <Container fluid>
            <Row className="justify-content-center  mx-4 py-3">
                <h3>Request FM For QR-Code</h3>
            </Row>
            <Row className="justify-content-center  mx-4 py-3">
                <Col
                    sm={10}
                    lg={5}
                    className=" d-flex flex-column justify-content-center"
                >
                    <FormGroup>
                        <Label>FM Email</Label>
                        <Input
                            type="email"
                            value={email}
                            placeholder="Email"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </FormGroup>
                    <Button
                        className="w-50 mx-auto my-3"
                        color="primary"
                        disabled={email == ""}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                    <h5>
                        <b>
                            <u>Note:</u> To make a momento, you will need
                            videos.Ask your Family Members to provide Videos
                            with QR Code links. Tell your Family Members to post
                            their Videos at YouTube using the setting of
                            'Unlisted'.
                        </b>
                    </h5>
                </Col>
            </Row>
        </Container>
    );
};

export default RequestQRCode;
